import React, { ReactElement } from 'react';
import FlexContainer from '../flex-container/flex-container.component';
import PaddedFlexContainer from '../padded-flex-container/padded-flex-container.component';
import useStylesIconTextBlock from './icon-text-block.styles';

const IconTextBlock: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    icon,
    children,
  } = props;

  const { classes } = useStylesIconTextBlock();

  return (
    <FlexContainer>
      {
        !!icon && (
          <PaddedFlexContainer isSmall className={classes.iconTextBlockIcon}>
            {icon}
          </PaddedFlexContainer>
        )
      }
      {
        !!children && (
          <FlexContainer>
            {children}
          </FlexContainer>
        )
      }
    </FlexContainer>
  );
});

export default IconTextBlock;
